import { LoadableLazy } from '@confluence/loadable';

export const ReadingAidsPopup = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-readingAidsPopup" */ '../src/ReadingAidsPopup'))
			.ReadingAidsPopup,
});
